import Logo from "@/assets/regions/oxfordshire-logo.svg";
import { RiskLevel } from "@/model/RiskLevel";
import { DefaultLower, NullBanner } from "@/model/DefaultBanners";
const DefaultBanner = {
    rawCopy: "For information about local alcohol advice and support, " +
        "visit the <u>Oxfordshire Wellbeing Cloud website.</u>",
    logoLink: "http://wellbeing.turning-point.co.uk/oxfordshire/"
};
export default {
    name: "Oxfordshire",
    logo: {
        file: Logo,
        width: 155,
        height: 40
    },
    hasFreeAppointments: true,
    showServiceInfoOnResultsSummaryPage: true,
    bannerInfo: {
        default: NullBanner,
        [RiskLevel.Lower]: DefaultLower,
        [RiskLevel.Increasing]: DefaultBanner,
        [RiskLevel.Higher]: DefaultBanner,
        [RiskLevel.High]: DefaultBanner
    },
    regions: [
        "Cherwell",
        "Oxford City",
        "South Oxfordshire",
        "Vale of the White Horse",
        "West Oxfordshire"
    ],
    clinics: [
        {
            name: "Turning Point Oxfordshire",
            description: "hide",
            phone: ["0300 0134 776"],
            // email: "turningpoint.oxon@nhs.net",
            website: "https://www.turning-point.co.uk/services/oxfordshire",
            isPrimaryProvider: true,
            other_info: "Access free advice, information and support from Turning Point&apos;s " +
                "Oxfordshire Roads to Recovery.<br>Services are provided across Oxfordshire " +
                "for adults aged 18 and over.<br><br>" +
                "For more information or to find a Hub:",
            evenMoreInfo: "<br>Alternatively, drop in to one of the Hubs – no appointment needed. " +
                "Hub locations and opening times can be found " +
                "<a href='https://www.turning-point.co.uk/services/oxfordshire#opening-times' target='_blank'>here.</a>"
            // description: 'Email Turning Point: <a href="mailto:${email}">${email}</a>'
        },
        {
            name: "Cranstoun Here4YOUth",
            isPrimaryProvider: true,
            tagline: "Cranstoun Here4YOUth offers support to families as well as individuals up to the age of 25.",
            phone: ["01865 590825"],
            email: "here4youthox@cranstoun.org.uk",
            website: "https://cranstoun.org/help-and-advice/young-people/oxfordshire-here4youth/"
        },
        {
            name: "Turning Point Oxford",
            address: "Rectory Road, Oxford, OX4 1BU",
            location: { lat: 51.7491954, lng: -1.2384217999999692 },
            phone: ["0300 0134 776"],
            email: "turningpoint.oxon@nhs.net",
            times: [
                {
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1900 }],
                        wednesday: [{ start: 1200, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }],
                        saturday: [{ start: 1030, end: 1400 }]
                    }
                }
            ],
            website: "http://wellbeing.turning-point.co.uk/oxfordshire/hubs/oxford-hub/"
        },
        {
            name: "Turning Point Banbury",
            location: { lat: 52.0619886, lng: -1.3315652 },
            address: "Banbury Health Centre, 58 Bridge Street, Banbury, OX16 5QD",
            phone: ["01295 225 544"],
            email: "turningpoint.oxon@nhs.net",
            times: [
                {
                    times: {
                        monday: [{ start: 900, end: 1900 }],
                        tuesday: [{ start: 900, end: 1830 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            website: "http://wellbeing.turning-point.co.uk/oxfordshire/hubs/banbury-hub/"
        },
        {
            name: "Turning Point Witney",
            location: { lat: 51.78430849999999, lng: -1.4864095000000361 },
            address: "Marlborough House, Marlborough Lane, Witney, Oxon, OX28 6DY",
            phone: ["01993 849 405"],
            email: "turningpoint.oxon@nhs.net",
            times: [
                {
                    info: "(Mondays on alternate weeks)",
                    times: {
                        monday: [{ start: 900, end: 1900 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            website: "http://wellbeing.turning-point.co.uk/oxfordshire/hubs/witney-hub/"
        },
        {
            name: "Turning Point Didcot",
            location: { lat: 51.60665880000001, lng: -1.2401012000000264 },
            address: "The Glass Tower, 6 Station Road, Orchard Centre, Didcot, Oxon, OX11 7LL",
            phone: ["01235 514 360"],
            email: "turningpoint.oxon@nhs.net",
            times: [
                {
                    times: {
                        monday: [{ start: 900, end: 1900 }],
                        tuesday: [{ start: 900, end: 2000 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            website: "http://wellbeing.turning-point.co.uk/oxfordshire/hubs/didcot-hub/"
        }
    ]
};
//# sourceMappingURL=Oxfordshire.js.map